import type { Address } from 'viem';
import type { EncodedTx } from '../types.js';
import type { SignerStrategy } from './index.js';
import { encodeDelegatedAction } from '../encoder.js';

/**
 * Delegated signer — the private key belongs to a delegate account that has
 * been granted access via trading.setDelegate() by the actual trader.
 *
 * prepare() wraps every transaction in delegatedAction(traderAddress, callData)
 * so the delegate can execute the trade on the trader's behalf.
 */
export class DelegatedSignerStrategy implements SignerStrategy {
  readonly traderAddress: Address;

  constructor(traderAddress: Address) {
    this.traderAddress = traderAddress;
  }

  prepare(encoded: EncodedTx): EncodedTx {
    return encodeDelegatedAction(this.traderAddress, encoded.data, encoded.to);
  }
}
